import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { IErrorInfo } from '@scl/shared/models/error-info';
import { AppResponseBase } from '@scl/shared/models/app-response-base';

@Injectable({
  providedIn: 'root'
})
export class ErrorReportService {
  private apiUrl = `${environment.apiUrlBase}/api/errors`;

  private readonly _currentError: BehaviorSubject<IErrorInfo | null> = new BehaviorSubject<IErrorInfo | null>(null);
  readonly currentError$ = this._currentError.asObservable();

  constructor(private http: HttpClient) { }

  setError(error: IErrorInfo): void {
    // Generate error ID if not provided
    if (!error.errorId) {
      error.errorId = this.generateErrorId();
    }
    
    // Set timestamp if not provided
    if (!error.timestamp) {
      error.timestamp = new Date();
    }

    // Set current URL if not provided
    if (!error.url) {
      error.url = window.location.href;
    }

    this._currentError.next(error);
  }

  getError(): IErrorInfo | null {
    return this._currentError.value;
  }

  clearError(): void {
    this._currentError.next(null);
  }

  sendErrorReport(error: IErrorInfo): Observable<AppResponseBase<any>> {
    return this.http.post<AppResponseBase<any>>(`${this.apiUrl}/report`, error);
  }

  private generateErrorId(): string {
    const timestamp = Date.now().toString(36);
    const randomStr = Math.random().toString(36).substring(2, 9);
    return `ERR-${timestamp}-${randomStr}`.toUpperCase();
  }
}
